/* Onglet « Confidentialité / RGPD » des paramètres — extrait tel quel de
 * AccountSettingsPage.tsx (markup/classes identiques). L'état d'export et la
 * suppression restent gérés par le parent (props). */

export default function PrivacyTabContent({
  exportLoading,
  exportError,
  exportSuccess,
  onExport,
  onRequestDelete,
}: {
  exportLoading: boolean;
  exportError: string | null;
  exportSuccess: boolean;
  onExport: () => void;
  onRequestDelete: () => void;
}) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-slate-900">Confidentialité & données personnelles</h2>

      <p className="text-sm text-slate-600">
        Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de portabilité et de suppression sur vos données personnelles. Ces actions sont directement accessibles ci-dessous.
      </p>

      {/* Export data */}
      <div className="bg-slate-50 rounded-lg p-5 space-y-3">
        <div>
          <h3 className="text-sm font-semibold text-slate-900 mb-1">
            Exporter mes données personnelles
          </h3>
          <p className="text-xs text-slate-600">
            Téléchargez l'intégralité des données personnelles vous concernant dans un fichier JSON structuré : profil, organisation, historique d'analyses, événements d'usage et factures. Ce droit est garanti par l'article 20 du RGPD (droit à la portabilité).
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onExport}
            disabled={exportLoading}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-100 transition-colors disabled:opacity-50"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            {exportLoading ? 'Préparation...' : 'Télécharger mes données (JSON)'}
          </button>
          {exportSuccess && (
            <span className="text-sm text-emerald-600">Téléchargement lancé</span>
          )}
          {exportError && (
            <span className="text-sm text-red-500">{exportError}</span>
          )}
        </div>
      </div>

      {/* Delete account */}
      <div className="bg-red-50 border border-red-200 rounded-lg p-5 space-y-3">
        <div>
          <h3 className="text-sm font-semibold text-red-800 mb-1">
            Supprimer mon compte
          </h3>
          <p className="text-xs text-red-700/80">
            La suppression de votre compte est définitive et irréversible. Elle entraîne l'effacement de votre profil, de l'intégralité de votre historique d'analyses, et de vos événements d'usage. Conformément à l'article 17 du RGPD (droit à l'effacement).
          </p>
          <p className="text-xs text-red-700/70 mt-2">
            <strong>Exception légale :</strong> les enregistrements de facturation (factures, paiements) sont conservés sous forme anonymisée pendant dix ans pour respecter les obligations comptables françaises.
          </p>
        </div>
        <button
          onClick={onRequestDelete}
          className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
        >
          Supprimer définitivement mon compte
        </button>
      </div>

      {/* Your rights */}
      <div className="bg-slate-50 rounded-lg p-5 space-y-2">
        <h3 className="text-sm font-semibold text-slate-900">Vos autres droits RGPD</h3>
        <p className="text-xs text-slate-600">
          Pour toute demande relative au droit d'accès, de rectification, d'opposition ou de limitation du traitement, contactez-nous à <a href="mailto:privacy@blackthornsdesign.com" className="text-violet-600 hover:underline">privacy@blackthornsdesign.com</a>. Vous pouvez également déposer une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-violet-600 hover:underline">www.cnil.fr</a>) si vous estimez que vos droits ne sont pas respectés.
        </p>
      </div>
    </div>
  );
}
